<template>
<svg viewBox="0 0 49 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-stop`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.503 8.444c8.591-8.592 22.52-8.592 31.112 0 8.592 8.591 8.592 22.52 0 31.112-8.591 8.592-22.52 8.592-31.112 0-8.592-8.591-8.592-22.52 0-31.112zm4.32 1.492l25.3 25.3c5.66-7.067 5.215-17.412-1.336-23.964-6.552-6.551-16.897-6.997-23.965-1.336zm-2.829 2.828l25.3 25.3c-7.067 5.66-17.412 5.215-23.963-1.336-6.551-6.551-6.997-16.896-1.337-23.964z"/></svg>
</template>
<script>

export default {
  name: 'IconStop',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
